import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import GameCard from '../components/GameCard';
import { games } from '../data/games';
import { Game } from '../types/game';
import './Favorites.css';

const Favorites: React.FC = () => {
  const navigate = useNavigate();
  const [favoriteGames, setFavoriteGames] = useState<Game[]>([]);

  useEffect(() => {
    // Load favorites from localStorage or state
    const favorites = JSON.parse(localStorage.getItem('favorites') || '[]');
    const favoriteGamesList = games.filter((game) =>
      favorites.includes(game.id)
    );
    setFavoriteGames(
      favoriteGamesList.map((game) => ({ ...game, isFavorite: true }))
    );
  }, []);

  const handleFavoriteToggle = (gameId: string) => {
    setFavoriteGames((prev) => {
      const updated = prev.filter((game) => game.id !== gameId);
      const favorites = updated.map((g) => g.id);
      localStorage.setItem('favorites', JSON.stringify(favorites));
      return updated;
    });
  };

  return (
    <div className="favorites-page">
      <div className="favorites-header">
        <button
          className="back-button"
          onClick={() => navigate(-1)}
          aria-label="Go back"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M19 12H5M12 19l-7-7 7-7"/>
          </svg>
        </button>
        <h1 className="favorites-title">FAVORITE GAMES</h1>
        <button className="search-button" aria-label="Search">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8"></circle>
            <path d="m21 21-4.35-4.35"></path>
          </svg>
        </button>
      </div>

      {favoriteGames.length === 0 ? (
        <div className="empty-favorites">
          <div className="empty-icon">❤️</div>
          <p className="empty-text">The favorite list is empty</p>
          <button
            className="browse-button"
            onClick={() => navigate('/')}
          >
            Browse Games
          </button>
        </div>
      ) : (
        <div className="favorites-grid">
          {favoriteGames.map((game) => (
            <GameCard
              key={game.id}
              game={game}
              onFavoriteToggle={handleFavoriteToggle}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default Favorites;

